import { GeoPoint, Timestamp } from 'firebase/firestore'
import { z } from 'zod'

import { TeamStatusZod } from './TeamStatusZod.ts'

export const TeamZod = z.object({
  piloteId: z.number(),
  number: z
    .number()
    .nullable()
    .transform((v) => (v === null ? '' : String(v))),
  status: TeamStatusZod,
  vip: z.boolean().optional().default(false),
  base: z.string().optional(),
  startingLocation: z.string().optional(),
  startingLocationPiloteId: z.number().optional(),
  vehicle: z.object({
    electric: z.boolean(),
    manual: z.boolean(),
  }),
  usingMobileApplication: z.boolean().optional().default(false),
  availableGeolocation: z.instanceof(GeoPoint).optional(),
  completedTransportRequestCount: z.number().optional().default(0),
  availableSince: z
    .instanceof(Timestamp)
    .transform((v) => v.toDate())
    .optional(),
  messagingStatus: z
    .object({
      teamMessageCount: z.number().optional().default(0),
      hasUnreadTeamMessages: z.boolean().optional().default(false),
      hasUnreadAdminMessages: z.boolean().optional().default(false),
    })
    .optional()
    .default({ teamMessageCount: 0, hasUnreadTeamMessages: false, hasUnreadAdminMessages: false }),
  transportRequest: z
    .object({
      id: z.string(),
      status: z.enum(['allocated', 'assigned', 'on_board']),
    })
    .optional(),
})
